import { useSuspenseQuery } from "@tanstack/react-query";
import { type LendingApiClient, useApi } from "@lending/lib/api";
import { STANDARD_QUERY_CACHE_CONFIG } from "@lending/lib/queryConfig";

function getEligibilityCriteriaQueryOptions($api: LendingApiClient) {
  return $api.queryOptions(
    "get",
    "/v2/lending/eligibility_criteria/",
    {},
    STANDARD_QUERY_CACHE_CONFIG
  );
}

function useGetEligibilityCriteriaQuery() {
  const $api = useApi();
  const query = useSuspenseQuery(getEligibilityCriteriaQueryOptions($api));

  return {
    eligibilityCriteriaData: query.data,
    eligibilityCriteria: query.data?.results ?? [],
    hasEligibilityCriteria: (query.data?.count ?? 0) > 0,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}

export { useGetEligibilityCriteriaQuery, getEligibilityCriteriaQueryOptions };
